import React, { useEffect, useState } from "react";
import Moon from "./images/moon.png";
import { Projects } from "./components/Projects";
import { Stack } from "./components/Stack";
import { motion } from "framer-motion";
import Gonzalo from "./images/gonzalo.png";
import Linkedin from "./images/linkedin.png";
import Github from "./images/github.png";
import Resume from "./images/resume.png";

export const Home = () => {
	const [scroll, setScroll] = useState(0);
	const [currentOpen, setCurrentOpen] = useState("");

	useEffect(() => {
		const scrollListener = window.addEventListener("scroll", () => {
			setScroll(window.scrollY);
		});
		setTimeout(() => {
			window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
		}, 500);
		return () => {
			window.removeEventListener("scroll", scrollListener);
		};
	}, []);

	const container = {
		hidden: { opacity: 0 },
		show: {
			opacity: 1,
			transition: {
				staggerChildren: 0.05,
			},
		},
	};

	const item = {
		hidden: { opacity: 0, y: 100 },
		show: {
			opacity: 1,
			y: 0,
			transition: {
				duration: 0.3,
			},
		},
	};

	return (
		<div className="w-full flex flex-col justify-center items-center home">
			<img
				src={Moon}
				className="fixed top-0 left-50 z-10 moon"
				style={{
					width: "90%",
					maxWidth: "450px",
				}}
			/>
			<div className="flex flex-col justify-center items-center w-full  text-shadow z-50">
				{currentOpen === "" ? (
					<>
						{" "}
						<div className="flex py-2 justify-center items-center flex-col w-full z-50 transition-all duration-500">
							<motion.h1
								className="text-3xl md:text-5xl font-black "
								style={{
									textShadow: "0 0 10px #fff",
								}}
							>
								Gonzalo Alonso
							</motion.h1>
							<h2
								className="text-xl md:text-2xl font-black"
								style={{
									textShadow: "0 0 10px #fff",
								}}
							>
								Software Developer
							</h2>
						</div>
					</>
				) : currentOpen === "Projects" ? (
					<Projects close={() => setCurrentOpen("")} />
				) : currentOpen === "Stack" ? (
					<Stack close={() => setCurrentOpen("")} />
				) : (
					<></>
				)}
			</div>
			{currentOpen === "" && (
				<>
					<motion.div
						className="flex flex-col md:flex-row bottom-2 md:bottom-6 md:grid grid-cols-6 gap-2 md:gap-6 w-11/12 mx-auto max-w-5xl items-center justify-center z-20"
						variants={container}
						initial="hidden"
						whileInView="show"

					>
						<motion.div
							className="bg-black col-span-6 rounded-2xl p-2 md:p-6 flex flex-col lg:flex-row gap-12 bg-opacity-90 items-center justify-center"
							variants={item}
							style={{
								// border: "2px solid rgba(110, 180, 200)",
								boxShadow: "0 0 10px rgba(110, 180, 200)",
							}}

						>
							<GonzaloImage />
							<motion.p className="font-light text-xs lg:text-xl text-white"
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								transition={{ delay: 0.6 }}
							>
								<b className="lg:text-2xl font-black">
									👋🏻 Hello Everyone! Welcome to my portfolio.
								</b>{" "}
								<br />
								<br />I am a code enthusiast specialized in{" "}
								<b className="font-black">Fullstack Web </b>
								technologies, from secure and efficient{" "}
								<b className="font-black">back-ends</b>,
								to clean and user friendly <b className="font-black">front-end</b>{" "}
								interfaces. <br /><br />
								I hope you enjoy your visit, feel free to check out my projects and tech stack below!
								<br />
								<br />
								<a
									href="mailto:gonalonso.gar@gmail.com"
									target="_blank"
									className="font-black underline"
									style={{
										color: "rgba(110, 180, 200,1)",
									}}
								>
									📥 gonalonso.gar@gmail.com.
								</a>
							</motion.p>
						</motion.div>
						<motion.div
							className="header-button cta col-span-3"
							onClick={() => setCurrentOpen("Projects")}
							variants={item}
						>
							Projects
						</motion.div>
						<motion.div
							className="header-button col-span-3"
							onClick={() => setCurrentOpen("Stack")}
							variants={item}
						>
							Tools/tech
						</motion.div>
						<motion.a
							className="header-button small col-span-2"
							href="/gonzalo.pdf"
							target="_blank"
							variants={item}
							itemRef=""
						>
							<label className="flex flex-1 justify-center cursor-pointer">
								Resume
							</label>
							<img src={Resume} className="w-4 md:w-8" />
						</motion.a>
						<motion.a
							className="header-button small col-span-2"
							variants={item}
							target="_blank"
							href="https://www.linkedin.com/in/galonsog/"
						>
							<label className="flex flex-1 justify-center cursor-pointer">
								Linkedin
							</label>
							<img src={Linkedin} className="w-4 md:w-8" />
						</motion.a>
						<motion.a
							className="header-button small col-span-2"
							variants={item}
							target="_blank"
							href="https://github.com/gonzaloalonso123"
						>
							<label className="flex flex-1 justify-center cursor-pointer">
								Github
							</label>
							<img src={Github} className="w-4 md:w-8" />
						</motion.a>
					</motion.div>
				</>
			)}
		</div>
	);
};


const GonzaloImage = () => (
	<div className="mx-auto flex items-center justify-center relative  gonzalo-background">
		<motion.img
			src={Gonzalo}
			className=" z-10 object-cover"
			initial={{ opacity: 0, scale: 0.1 }}
			animate={{ opacity: 1, scale: 1 }}
			transition={{ delay: 0.4 }}
		/>

	</	div >
)